module.exports = __webpack_public_path__ + "media/assets/img/flags/eu-EU-f2b47440185ba76d7ad1dc517d6a30fe.png";